import React, { useEffect, useRef, useState } from "react";
import {
    PASSWORD_RULE_TIP,
    getResetPasswordError,
    isValidResetPassword,
} from "@/utils/password";

const PASSWORD_VISIBLE_ICON =
    "https://img.dmallcdn.com/dshop/202607/5b3b9d3a-43f4-430a-95c9-b9720ab13c89";
const PASSWORD_HIDDEN_ICON =
    "https://img.dmallcdn.com/dshop/202607/bb4b638e-2054-4258-a97e-781952df89f5";

function ForgotPasswordFlow(props) {
    const {
        step,
        data,
        codeCount,
        codeSending,
        onChange,
        onSendCode,
        onNextStep,
        onConfirmReset,
        onBack,
        onCancel,
    } = props;
    const isValidPhone = /^[1][0-9]{10}$/.test((data.phone || "").trim());
    const canClickCode = isValidPhone && !codeSending;
    const canGoNext = !!(data.code && data.code.length === 6);
    const passwordValue = (data.password || "").trim();
    const confirmValue = (data.confirmPassword || "").trim();
    const codeInputRef = useRef(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [triedSubmit, setTriedSubmit] = useState(false);
    const passwordErr =
        passwordValue || triedSubmit ? getResetPasswordError(passwordValue) : "";
    const confirmErr = confirmValue && confirmValue !== passwordValue
        ? "两次输入的新密码不一致"
        : triedSubmit && !confirmValue
        ? "请再次输入新密码"
        : "";
    const canConfirmReset =
        isValidResetPassword(passwordValue) && confirmValue === passwordValue;

    useEffect(() => {
        if (step !== "reset" && codeSending && codeInputRef.current) {
            codeInputRef.current.focus();
        }
        if (step !== "reset") {
            setTriedSubmit(false);
        }
    }, [step, codeSending]);

    return (
        <div className="forgotPasswordTab loginTab">


            {step !== "reset" && (
                <>
                    <div className="forgotHeader">
                        <div className="forgotTitle">忘记密码？</div>
                        <div className="forgotSubTitle">
                        请输入手机号并获取验证码，以便重置密码。验证码有效期为10分钟，如未收到，请尝试重新获取验证码。
                        </div>
                    </div>
                    <div className="stepBlock">
                        <div className="input">
                            <input
                                inputMode="numeric"
                                maxLength={11}
                                onChange={(e) => onChange(e, "phone")}
                                placeholder="请输入手机号"
                                value={data.phone}
                            />
                        </div>
                        <div className="smsCodeRow">
                            <div className="input codeInput">
                                <input
                                    inputMode="numeric"
                                    maxLength={6}
                                    onChange={(e) => onChange(e, "code")}
                                    placeholder="请输入验证码"
                                    ref={codeInputRef}
                                    value={data.code}
                                />
                            </div>
                            <span
                                className={codeSending ? "codeView isSending" : canClickCode ? "codeView isActive" : "codeView"}
                                onClick={canClickCode ? onSendCode : undefined}
                            >
                                {codeSending
                                    ? codeCount + "s后重新获取"
                                    : "获取验证码"}
                            </span>
                        </div>
                    </div>
                    <div
                        className={canGoNext ? "button verifyButton isActive" : "button verifyButton isDisabled"}
                        onClick={() => {
                            if (canGoNext) onNextStep();
                        }}
                    >
                        下一步
                    </div>
                    <div className="forgotBackView" onClick={onCancel}>
                       <span>←</span>返回登录
                    </div>
                </>
            )}

            {step === "reset" && (
                <>
                    <div className="stepBlock resetStepBlock">
                        <div className="stepBlockTitle">重新设置密码</div>
                        <div className="stepBlockDesc">
                            {PASSWORD_RULE_TIP}
                        </div>
                        <div className={passwordErr ? "resetPasswordField has-error" : "resetPasswordField"}>
                            <div className={passwordErr ? "input resetPasswordInput passwordInput is-error" : "input resetPasswordInput passwordInput"}>
                                <input
                                    maxLength={25}
                                    onChange={(e) => onChange(e, "password")}
                                    placeholder="请输入新密码"
                                    type={showPassword ? "text" : "password"}
                                    value={data.password}
                                />
                                <button
                                    aria-label={showPassword ? "隐藏密码" : "显示密码"}
                                    className={showPassword ? "passwordToggle isVisible" : "passwordToggle"}
                                    onClick={() => setShowPassword((value) => !value)}
                                    type="button"
                                >
                                    <img
                                        alt=""
                                        src={showPassword ? PASSWORD_VISIBLE_ICON : PASSWORD_HIDDEN_ICON}
                                    />
                                </button>
                            </div>
                            {passwordErr ? (
                                <div className="resetPasswordError">{passwordErr}</div>
                            ) : null}
                        </div>
                        <div className={confirmErr ? "resetPasswordField has-error" : "resetPasswordField"}>
                            <div className={confirmErr ? "input resetPasswordInput passwordInput is-error" : "input resetPasswordInput passwordInput"}>
                                <input
                                    maxLength={25}
                                    onChange={(e) => onChange(e, "confirmPassword")}
                                    placeholder="请再次输入新密码"
                                    type={showConfirmPassword ? "text" : "password"}
                                    value={data.confirmPassword}
                                />
                                <button
                                    aria-label={showConfirmPassword ? "隐藏密码" : "显示密码"}
                                    className={showConfirmPassword ? "passwordToggle isVisible" : "passwordToggle"}
                                    onClick={() => setShowConfirmPassword((value) => !value)}
                                    type="button"
                                >
                                    <img
                                        alt=""
                                        src={showConfirmPassword ? PASSWORD_VISIBLE_ICON : PASSWORD_HIDDEN_ICON}
                                    />
                                </button>
                            </div>
                            {confirmErr ? (
                                <div className="resetPasswordError">{confirmErr}</div>
                            ) : null}
                        </div>
                    </div>
                    <div
                        className={canConfirmReset ? "button resetButton isActive" : "button resetButton isDisabled"}
                        onClick={() => {
                            setTriedSubmit(true);
                            if (canConfirmReset) onConfirmReset();
                        }}
                    >
                        确认
                    </div>
                    <div className="forgotStepBackView" onClick={onBack} >
                        <span>←</span>返回上一步
                    </div>
                </>
            )}
        </div>
    );
}

export default ForgotPasswordFlow;
